import ReactPlayer from "react-player";
import { Play20Filled } from "@fluentui/react-icons";
import { Spinner } from "@fluentui/react-components";
import { useState } from "react";

interface ReactPlayerWrapperProps {
    url?: string;
    onPlay?: () => void;
    // Opt-in: only callers with their own (audited) download control suppress the native one.
    hideNativeDownload?: boolean;
}

const ReactPlayerWrapper = (props: ReactPlayerWrapperProps) => {
    const { url, onPlay, hideNativeDownload } = props;
    const [isReady, setIsReady] = useState(false);

    return (
        <>
         {/* #CC4ALL-7438 forced the file to preload in a hidden component so the second audio element could change the playTime on the progress bar */}
            <audio controls preload="auto" style={{
                display: "none",
            }}>
                <source src={url} type="audio/wav" />
                Your browser does not support the audio element.
            </audio>

            <div className="wrapupPlayerWrapper">
                {!isReady && <Spinner size="tiny" />}
                <ReactPlayer
                    controls
                    height="50px"
                    width="300px"
                    style={{ margin: "5px", display: isReady ? undefined : "none" }}
                    playIcon={<Play20Filled />}
                    url={url}
                    config={hideNativeDownload ? { file: { attributes: { controlsList: "nodownload" } } } : undefined}
                    onReady={() => setIsReady(true)}
                    onPlay={onPlay}
                />
            </div>
        </>
    );
};

export default ReactPlayerWrapper;